//import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

//import getChildProjects from 'api/requests/partnership/getChildProjects';
import HTTPService from '@/services/Http';

async function fetchPartnerList({ commit }) {
  try {
    let page = 1;
    /*let isLastPage = false;
    const childProjects = [];
    const pageSize = 20;

    while (!isLastPage) {
      const childProjectsChunk = await HTTPService.getPartnerProjects(page);
      childProjects.push(childProjects);
      page++;
      isLastPage = childProjectsChunk.length < pageSize;
    }/**/

    // const { data } = await getChildProjects(axios);

    commit('SET_CHILD_PROJECTS', await HTTPService.getPartnerProjects(page));
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchPartnerList,
};
